module.exports = __webpack_public_path__ + "static/media/08B.1e547c8f.png";